import { fetchMe } from "./me";

// IAM role names from internal/authz/principal.go. A "normal user" holds
// neither role and sees only the self-service (/me) area.
export type RoleName = "super_admin" | "tenant_admin";

export interface Persona {
  isOperator: boolean; // super_admin -> /admin/v1 operator console
  isTenantAdmin: boolean; // tenant_admin -> tenant management
  isUser: boolean; // every authenticated principal -> /me
}

export function personaFromRoles(roles: RoleName[]): Persona {
  return {
    isOperator: roles.includes("super_admin"),
    isTenantAdmin: roles.includes("tenant_admin"),
    isUser: true,
  };
}

/** Resolve the principal's roles from the authoritative /me endpoint. */
export async function resolveRoles(): Promise<RoleName[]> {
  const me = await fetchMe();
  return me.roles.filter(
    (role): role is RoleName =>
      role === "super_admin" || role === "tenant_admin",
  );
}
